import * as Sentry from '@sentry/browser';
import './modules/backend/navigation';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_SENTRY_REL,
  environment: import.meta.env.VITE_APP_ENV,
});

import('@popperjs/core');
import('bootstrap');
